// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1XJQU","content":"ManualTimeModal_content__1Qfax"};